import { Activity, Key, Radio, Wrench, FileSignature, Wifi } from "lucide-react";

type Event = {
  ts: string;
  who: string;
  msg: string;
  icon: React.ReactNode;
  tone: "ok" | "warn" | "err" | "info";
};

const MOCK_EVENTS: Event[] = [
  {
    ts: "14:32",
    who: "carlos@spn",
    msg: "rotated AES key on PAD2 (master)",
    icon: <Key className="h-3 w-3" />,
    tone: "info",
  },
  {
    ts: "14:15",
    who: "edge-agent",
    msg: "PAD2/repeater-3 went offline (PA temp 73°C)",
    icon: <Wifi className="h-3 w-3" />,
    tone: "err",
  },
  {
    ts: "13:58",
    who: "uwe@spn",
    msg: "codeplug v1.4.2 deployed to MUC3 (3 repeaters)",
    icon: <FileSignature className="h-3 w-3" />,
    tone: "ok",
  },
  {
    ts: "13:41",
    who: "andrea@spn",
    msg: "scheduled maintenance visit at LEJ5 for 2026-05-24",
    icon: <Wrench className="h-3 w-3" />,
    tone: "info",
  },
  {
    ts: "13:22",
    who: "edge-agent",
    msg: "PAD2/repeater-3 came back online",
    icon: <Wifi className="h-3 w-3" />,
    tone: "ok",
  },
  {
    ts: "12:09",
    who: "system",
    msg: "BNetzA reminder: 4 DE frequencies expire in <90d",
    icon: <FileSignature className="h-3 w-3" />,
    tone: "warn",
  },
  {
    ts: "11:54",
    who: "lisa@spn",
    msg: "uploaded heatmap survey for NUE1 (P1+P2+outdoor)",
    icon: <Radio className="h-3 w-3" />,
    tone: "info",
  },
  {
    ts: "10:47",
    who: "edge-agent",
    msg: "LEJ4/master VSWR 1.4 — within bounds",
    icon: <Wifi className="h-3 w-3" />,
    tone: "ok",
  },
];

const TONES: Record<Event["tone"], string> = {
  ok: "text-emerald-400",
  warn: "text-amber-400",
  err: "text-red-400",
  info: "text-sky-400",
};

export function ActivityFeed() {
  return (
    <aside className="hidden xl:flex w-80 flex-col border-l border-zinc-800/80 bg-zinc-900/30">
      <div className="px-4 py-3 border-b border-zinc-800/80 flex items-center gap-2">
        <Activity className="h-3.5 w-3.5 text-emerald-400" />
        <span className="text-xs font-mono uppercase tracking-widest text-zinc-400">
          Live Activity
        </span>
        <span className="ml-auto h-1.5 w-1.5 rounded-full bg-emerald-400 pulse-dot" />
      </div>
      <ol className="flex-1 overflow-auto px-3 py-2 space-y-0.5 text-xs font-mono">
        {MOCK_EVENTS.map((ev, i) => (
          <li
            key={i}
            className="flex items-start gap-2 px-2 py-1.5 rounded hover:bg-zinc-800/50"
          >
            <span className="text-zinc-600 shrink-0">{ev.ts}</span>
            <span className={`shrink-0 mt-0.5 ${TONES[ev.tone]}`}>{ev.icon}</span>
            <span className="text-zinc-300 leading-snug">
              <span className="text-zinc-500">{ev.who}</span> {ev.msg}
            </span>
          </li>
        ))}
      </ol>
      <div className="px-3 py-2 border-t border-zinc-800/80 text-[10px] font-mono text-zinc-600">
        ws://api.amzel.io/v1/audit/stream · subscribed
      </div>
    </aside>
  );
}
